import { render, staticRenderFns } from "./Coins.vue?vue&type=template&id=351d5c7f&scoped=true&lang=pug"
import script from "./Coins.vue?vue&type=script&lang=js"
export * from "./Coins.vue?vue&type=script&lang=js"
import style0 from "./Coins.vue?vue&type=style&index=0&id=351d5c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d5c7f",
  null
  
)

export default component.exports